import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'
import { Link } from 'react-router-dom'
import { CSSTransition } from 'react-transition-group';


import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { locale } from 'primereact/api';

import LoadingView from '@components/LoadingView';

import { login, getUserInfo } from '@actions/auth';
import { getAllLanguagesList, getDictionaryLanguage } from '@actions/locale';
import { setCatalogLanguageItems } from '@actions/catalogs';

import { rexgexEmail, validateValuesLanguages } from '@utils/general'

import { AUTHORIZATION, CURRENT_LENGUAGE, LANGUAGE_DEFAULT } from '@constants/general'

import './style.scss'

const maximumAttemptsSession = 5

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: false,
      btnSubmitLoading: false,
      email: '',
      password: '',
      errors: [],
      languageSelected: '',
      expandedLanguage: false,
      timesValidate: 1,
    };
  }

  async componentDidMount() {
    const { location } = this.props
    const { search } = location
    const isFromMicrositio = new URLSearchParams(search).get('path');
    if (isFromMicrositio) {
      console.log("Redirect de micrositio ***")
      this.setState({loadingPage: true})
      setTimeout(() => {
        this.validateSession(isFromMicrositio)
      }, 5000)
    } else {
      console.log("No viene de microsito")
      this.validateSession()
    }
  }
  
  // validateSession = () => {
  //   const { getUserInfo, history, location } = this.props
  //   const { timesValidate } = this.state
  //   window.getValueFromIframe()
  //   setTimeout(async () => {
  //     const token = localStorage.getItem(AUTHORIZATION);
  //     console.log('token', token)
  //     if (token && token !== 'null') {
  //       this.setState({btnSubmitLoading: true})
  //       const response = await getUserInfo()
  //       const { search } = location
  //       const path = new URLSearchParams(search).get('path');
  //       if (!response?.status) history.push(path || "/dashboard")
  //     } else {
  //       this.setState({timesValidate: true})
  //       if (!timesValidate) this.validateSession()
  //     }
  //     this.initLogin()
  //   }, 500)
  // }

  validateSession = (isFromMicrositio = false) => {
    const { getUserInfo, history, location } = this.props
    const { timesValidate } = this.state
    console.log('2.Validate')
    window.getValueFromIframe()
    setTimeout(async () => {
      const token = localStorage.getItem(AUTHORIZATION);
      if (token && token !== 'null') {
        this.setState({btnSubmitLoading: true})
        const response = await getUserInfo()
        const { search } = location
        const path = new URLSearchParams(search).get('path');
        if (!response?.status) history.push(path || "/dashboard")
      } else if (!isFromMicrositio) {
        this.setState({timesValidate: timesValidate + 1})
        if (timesValidate < maximumAttemptsSession) setTimeout( () => this.validateSession(), 1000 )
      }
      this.initLogin()
    }, 500)
  }
  
  initLogin = async () => {
    const { getAllLanguagesList, setCatalogLanguageItems } = this.props

    await getAllLanguagesList({type: 'all'})
    await setCatalogLanguageItems()
    this.setInitialLanguage()
    this.setState({btnSubmitLoading: false, loadingPage: false})

  }

  onChange = ({ target }) => {
    this.setState({ [target.name]: target.value }, this.validateFieldsOnchange(target.name, target.value));
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state;
    if (errors[name] && value) {
      delete errors[name];
      this.setState({ errors });
    }
  };

  validateFields = async () => {
    const { t } = this.props;
    const {email, password } = this.state;
    let errors = {};
    if (!email) errors = { ...errors, 'email': `${t('Correo electrónico')} ${t('es requerido')}`  }
    if (email && !rexgexEmail.test(email)) errors = { ...errors, 'email': `${t('Correo electrónico')} ${t('es invalido')}`  }
    if (!password) errors = { ...errors, 'password': `${t('Contraseña')} ${t('es requerido')}`  }
    this.setState({ errors });
    return errors;
  };

  onSubmit = async (e) => {
    e.preventDefault();
    this.setState({btnSubmitLoading: true})
    const { history, login } = this.props
    const { email, password } = this.state
    const validate = await this.validateFields()
    if (some(validate, {})) return this.setState({btnSubmitLoading: false})

    const response = await login({ email, password })
    if (!response.status) {
      history.push("/dashboard")
    }
    return this.setState({ btnSubmitLoading: false });
  };

  setInitialLanguage = async () => {
    const { itemsLanguageCatalog } = this.props
    if (!localStorage.getItem(CURRENT_LENGUAGE)) localStorage.setItem(CURRENT_LENGUAGE, LANGUAGE_DEFAULT)
    const currentLanguage = localStorage.getItem(CURRENT_LENGUAGE)
    const getLanguage = itemsLanguageCatalog.find(item => item.key === currentLanguage)
    await this.setDictionaryLanguge(currentLanguage)
    this.setState({ languageSelected: getLanguage?.label })
  }

  setDictionaryLanguge = async (key) => {
    const { getDictionaryLanguage, i18n } = this.props
    const language = await getDictionaryLanguage(key)
    if (!language?.status) {
      const valiteEmptyValues = validateValuesLanguages(language.data)
      i18n.addResourceBundle(key, 'translation', valiteEmptyValues, true, true)
      i18n.changeLanguage(key);
    }
  }

  onClickLanguage = () => {
    const { expandedLanguage } = this.state
    this.setState({
      expandedLanguage: !expandedLanguage
    })
  }

  onChangeLenguage = async (key) => {
    const { i18n, setCatalogLanguageItems } = this.props
    await this.setDictionaryLanguge(key)
    i18n.changeLanguage(key);
    locale(key)
    localStorage.setItem(CURRENT_LENGUAGE, key)
    const languageCatalog = await setCatalogLanguageItems()
    const getLanguage = languageCatalog.find(item => item.key === key)
    this.setState({languageSelected: getLanguage.label})
  }

  render() {
    const { t, itemsLanguageCatalog } = this.props;
    const { loadingPage, email, password, btnSubmitLoading, errors, languageSelected, expandedLanguage } = this.state;

    const isFormFieldValid = (name) => !!errors[name];
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const renderLanguages = (
      (itemsLanguageCatalog || []).map(item => (
        <li key={`language-${item.key}`}>
          <button type="button" className="p-link" onClick={() => this.onChangeLenguage(item.key)}>
            <span>{item.label}</span>
          </button>
        </li>
      ))
    )

    if (loadingPage) return  (<LoadingView/>)

    return (
      <section className="login is-full-height">
      <div className="p-d-flex is-full-height p-jc-center" style={{"position": "relative"}}>
        <div className="p-col-12 p-md-5" style={{"position": "absolute", "zIndex": "100"}}>
        {/* <div className="login-content-img">
          <img className="is-full-width" src="assets/img/logo-compliance.svg" width="117" height="100" alt="amx_logo"/>
        </div> */}
          <div className="card p-fluid card-border p-px-5">
            {/* <div className="p-grid">
            </div> */}
              <div className="p-col">
                <img className="is-full-width" src="/assets/img/logo-compliance.svg" width="117" height="200" alt="amx_logo"/>
              </div>
            <form onSubmit={this.onSubmit} className="p-fluid" autoComplete='new-password'>
              <div className="p-field">
                <label
                  htmlFor="email"
                >
                {t('Correo electrónico')}
                </label>
                <InputText
                  name="email"
                  type="text"
                  value={email}
                  onChange={this.onChange}
                  autoFocus
                  autoComplete='none'
                  className={classNames({
                    'p-invalid': isFormFieldValid(`email`),
                  })}
                />
                {getFormErrorMessage('email')}
              </div>
              <input id="username" style={{"display":"none"}} type="text" name="fakeusernameremembered"/>
              <input id="password" style={{"display":"none"}} type="password" name="fakepasswordremembered"/>
              <div className="p-field">
                <label
                  htmlFor="Contraseña"
                >
                {t('Contraseña')}
                </label>
                <Password
                  name="password"
                  type="text"
                  maxLength={12}
                  toggleMask
                  feedback={false}
                  value={password}
                  autoComplete='new-password'
                  onChange={this.onChange}
                  className={classNames({
                    'p-invalid': isFormFieldValid(`password`),
                  })}
                />
                {getFormErrorMessage('password')}
              </div>
              <Button type="submit" label={t('Ingresar')} className="p-button" loading={btnSubmitLoading} loadingoptions={{ position: 'right' }}/>
            </form>
            <div className="p-text-center p-mt-5">
              <Link to="/forgot-password">{t('¿Olvidaste tu contraseña?')}</Link>
            </div>
            <div className="p-col layout-profile">
                <button
                  className="p-link layout-profile-link"
                  type="button"
                  onClick={ () => this.onClickLanguage()}
                >
                  <span className="username"><u>{languageSelected}</u></span>
                  <i className="pi pi-globe" />
                </button>
                <CSSTransition
                  classNames="p-toggleable-content"
                  timeout={{ enter: 1000, exit: 450 }}
                  in={expandedLanguage}
                  unmountOnExit
                >
                  <ul className={classNames('login-language', {'layout-profile-expanded': expandedLanguage })}>
                    { renderLanguages }
                  </ul>
                </CSSTransition>
              </div>
          </div>
        </div>
      </div>
      <div className="custom-shape-divider-bottom-1622499295">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" className="shape-fill" />
            <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" className="shape-fill" />
            <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" className="shape-fill" />
        </svg>
    </div>
    <div className="label-version">
      <p>v 2.3.4</p>
    </div>
    </section>
    );
  }
}

const mapDispatchToProps = {
  login,
  getUserInfo,
  getAllLanguagesList,
  setCatalogLanguageItems,
  getDictionaryLanguage
};

const mapStateToProps = (state) => ({
  itemsLanguageCatalog: state.catalogs.itemsLanguageCatalog,
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Login);
